// extracted by mini-css-extract-plugin
export var cellWrapper = "Cell-module--cellWrapper--4f400";